import { useEffect } from 'react';
import { filterToExpression } from '@utils/filterUtils';
import { deserializeSortItem, isNullOrUndefined, serializeSortItem } from '@utils/utils';
import { useAvContext } from '../context/AvContextProvider';
import { useCustomSearchParams } from './UseCustomSearchParams2';

const parseOLTPPaginationOrderBy = parsedOrderBy =>
  !(isNullOrUndefined(parsedOrderBy?.property) || isNullOrUndefined(parsedOrderBy?.isAsc))
    ? {
        sortBy: parsedOrderBy.property,
        order: parsedOrderBy.isAsc ? 'asc' : 'desc',
      }
    : undefined;

const useOLTPPagination = (customTypeMap = {}) => {
  const {
    accountEntities: { fieldTypeMap },
  } = useAvContext();
  const [urlFilters, setUrlFilters] = useCustomSearchParams();
  const { orderBy, tablePage, ...restFilters } = urlFilters;
  const parsedOrderBy = orderBy.map(deserializeSortItem);

  const onSort = (property, direction) => {
    const isAsc = direction === 'asc';
    const nextOrderBy = [...orderBy.filter(item => item.property !== property).slice(0, 0), ...(direction ? [{ property, isAsc }] : [])];
    setUrlFilters({ ...urlFilters, orderBy: nextOrderBy.map(serializeSortItem) });
  };

  const setPageNumber = newPageNumber => setUrlFilters({ ...urlFilters, tablePage: newPageNumber });
  const nonEmptyFilters = Object.fromEntries(Object.entries(restFilters).filter(([, value]) => !Array.isArray(value) || value.length > 0));
  const filter = filterToExpression({ ...fieldTypeMap, ...customTypeMap }, nonEmptyFilters);

  useEffect(() => {
    setPageNumber(0);
  }, [JSON.stringify(restFilters), orderBy]);

  return {
    pageNumber: tablePage,
    parsedOrderBy,
    setPageNumber,
    filter,
    nonEmptyFilters,
    onSort,
    sort: parseOLTPPaginationOrderBy(parsedOrderBy?.[0]),
  };
};

export default useOLTPPagination;
